import { STANDALONE_WIZARD_KEY } from './accountingConstants';

export default function AccountingPlaybookSection({
  playbook,
  onStartFix,
  renderFixWizard,
  activeFindingKey,
  scanRan,
}) {
  return (
    <div className="admin-panel">
      {activeFindingKey === STANDALONE_WIZARD_KEY && renderFixWizard?.()}
      <h5>{playbook?.title || 'Step-by-step fix guide'}</h5>
      <p className="small text-muted">
        {playbook?.description || 'Run an integrity scan first (tab 1). Complete one step at a time, then scan again.'}
      </p>
      {!scanRan ? (
        <div className="admin-alert-item info">
          <strong>Scan required first</strong>
          <p className="small mb-0 mt-1">
            Open <em>Scan &amp; findings</em>, set your date range, and run the integrity scan. The guide is built from what we find.
          </p>
        </div>
      ) : !playbook?.steps?.length ? (
        <p className="text-muted small">No guided steps for this scan — your accounts look clear or issues are already listed on the scan tab.</p>
      ) : (
        <ol className="accounting-playbook-list">
          {playbook.steps.map((step) => (
            <li key={step.step} className="accounting-playbook-step">
              <div>
                <strong>Step {step.step}: {step.plain_label || step.label}</strong>
                <div className="small text-muted mt-1">{step.plain_reason || step.reason}</div>
              </div>
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={() => onStartFix({
                  fix_type: step.fix_type,
                  label: step.plain_label || step.label,
                  plain_label: step.plain_label,
                  params: step.params,
                })}
              >
                Start this fix
              </button>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
